'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var stickyOverflow = function stickyOverflow() {
  // Add negative overflow to each sticky item
  var updateStickyOverflow = function updateStickyOverflow() {
    var stickyItems = document.querySelectorAll('[data-sticky-overflow]');

    stickyItems.forEach(function (element, index) {
      var stickyItem = element;
      var stickyItemPadding = stickyItem.dataset.stickyOverflow;
      var headerSize = document.querySelector('.theme-header').offsetHeight;

      if (stickyItemPadding !== '') {
        var stickyItemPaddingElements = stickyItem.querySelectorAll(stickyItemPadding);

        stickyItemPaddingElements.forEach(function (elem, index) {
          elem.style.paddingTop = headerSize + 'px';
        });
      } else {
        stickyItem.style.paddingTop = headerSize + 'px';
      }

      stickyItem.style.marginTop = '-' + headerSize + 'px';
    });
  };

  window.addEventListener('resize', updateStickyOverflow);
  window.addEventListener('orientationchange', updateStickyOverflow);
  document.addEventListener('slick:resize', updateStickyOverflow);
  updateStickyOverflow();
};

exports.default = stickyOverflow;